module.exports = __webpack_public_path__ + "img/logo-dark.ae5e270c.png";